(function() {
    'use strict';

    angular.module('aprima-provider-api').factory('SettingRepository', [
        '$q',
        'SettingRepositoryTs',
        SettingRepository
    ]);

    function SettingRepository(
        $q,
        SettingRepositoryTs
    ) {
        return {
            getProviderEpcsSettings: getProviderEpcsSettings,
        };

        function getProviderEpcsSettings(userId, siteId) {
            var promise = SettingRepositoryTs.getProviderEpcsSettings(userId, siteId).toPromise();
            return $q.when(promise);
        }
    }
})();